import { useState } from "react";
import { ApiResponse, CustomServiceFormat, ContactData } from "../../interfaces/api-response";
import axiosInstance from "../Axios/axiosInstance";
import { url_contact } from "./useApiUrl";
import { ContactResult } from "../../interfaces/contact.interface";

// Servicio para agregar nuevo mensaje de contacto
export const useContactServiceAdd = (): CustomServiceFormat<ApiResponse<ContactData>, 'content', 'loading', 'error'> => {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    const content = async (formData: ContactResult): Promise<ApiResponse<ContactData> | undefined> => {
        setLoading(true);
        setError(null);

        try {
            const response = await axiosInstance.post<ApiResponse<ContactData>>(`${url_contact}/add`, formData);
            const result = response.data;
            setLoading(false);
            return result;
        } catch (error: any) {
            setError(error.response ? error.response.data.msg : error.message);
            setLoading(false);
            return undefined;
        }
    };

    return { content, loading, error };
};

